/* Brand detection — returns 'lumetier' or 'allure' based on the hostname,
   with a ?brand= query-string override for local development.

   Default is 'lumetier' so that:
     - lumetiercreatives.com           → Lumetier (the product)
     - the Emergent preview URL        → Lumetier (the product we're shipping)
     - localhost / dev                 → Lumetier (matches what staff see)

   The Allure photographer site shows only on:
     - allure-image.com (the photographer's own marketing domain)
     - any URL with ?brand=allure (for QA / preview)

   Why a helper and not a React hook: hostname doesn't change at runtime
   (without a full reload), so React state would be overkill. We just read
   window.location once when App renders.
*/
export function getBrand() {
  if (typeof window === "undefined") return "lumetier";
  try {
    const params = new URLSearchParams(window.location.search);
    const override = params.get("brand");
    if (override === "lumetier" || override === "allure") return override;
  } catch { /* ignore — URL parse failures fall through to hostname */ }
  const host = (window.location.hostname || "").toLowerCase();
  if (host.includes("allure-image")) return "allure";
  return "lumetier";
}
